import { Outlet, Navigate } from "react-router-dom"
import { useSelector } from "react-redux";
import { Cookie } from "../app/base/utils";

const UcaasValidation = () => {
  //const token: any = Cookie.get();
  const _login: any = useSelector((state: any) => state.login.login);
  //console.log("_login", _login)

  return (
    _login.is_ucas_user ? <Outlet /> : <Navigate to="/unauthorized" />
  )
  /* return (
    token && _login.isLoggedIn ? <Outlet /> : <Navigate to="/login" />
  ) */
}

export default UcaasValidation;